export default () => {
  let cryptoObj = window.crypto || window.msCrypto
  let array = new Uint32Array(1)
  return cryptoObj.getRandomValues(array)[0].toString()
}
